// Common Indian city coordinates for tracking (approx). Fallback = India center.
const CITIES = {
  delhi: [28.6139, 77.209],
  "new delhi": [28.6139, 77.209],
  mumbai: [19.076, 72.8777],
  bengaluru: [12.9716, 77.5946],
  bangalore: [12.9716, 77.5946],
  chennai: [13.0827, 80.2707],
  kolkata: [22.5726, 88.3639],
  hyderabad: [17.385, 78.4867],
  pune: [18.5204, 73.8567],
  jaipur: [26.9124, 75.7873],
  ahmedabad: [23.0225, 72.5714],
  lucknow: [26.8467, 80.9462],
  kochi: [9.9312, 76.2673],
  cochin: [9.9312, 76.2673],
  goa: [15.2993, 74.124],
  chandigarh: [30.7333, 76.7794],
  indore: [22.7196, 75.8577],
  nagpur: [21.1458, 79.0882],
  bhopal: [23.2599, 77.4126],
  surat: [21.1702, 72.8311],
  vadodara: [22.3072, 73.1812],
  patna: [25.5941, 85.1376],
  guwahati: [26.1445, 91.7362],
  shimla: [31.1048, 77.1734],
  dehradun: [30.3165, 78.0322],
  varanasi: [25.3176, 82.9739],
  agra: [27.1767, 78.0081],
  amritsar: [31.634, 74.8723],
  coimbatore: [11.0168, 76.9558],
  visakhapatnam: [17.6868, 83.2185],
  mysuru: [12.2958, 76.6394],
  mysore: [12.2958, 76.6394],
};

export function cityCoords(name) {
  if (!name) return null;
  return CITIES[name.trim().toLowerCase()] || null;
}

export function interpolate(a, b, t) {
  return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t];
}
